import { useContext } from "react"
import { StyleContext } from "./index.js"

/**
 * Send component stylesheet to server using context.
 *
 * @param {string} stylesheet
 */
export const sendStyles = (stylesheet) => {
  const collect = useContext(StyleContext)
  if (collect) collect(stylesheet)
}
